"use client";
import { jsxs as n, jsx as a } from "react/jsx-runtime";
import c from "clsx";
import { d as L, u as O } from "../../useTimer-4ikK9VfZ.js";
import k from "next/image";
import q from "next/link";
import { Box as z } from "../base/Base.js";
import { s as e } from "../../Offer.module-BtxYVTfL.js";
const F = ({
  image: i,
  endDate: y,
  href: d,
  onClick: o,
  onClose: t,
  title: g,
  days: x,
  hours: b,
  minutes: E,
  seconds: S,
  theme: l = "friday",
  timerColor: _ = "orange",
  children: r,
  ...m
}) => {
  const j = y || L().endOf("day").format(), s = O(j), f = (s == null ? void 0 : s.days) === 0, u = f && (s == null ? void 0 : s.hours) === 0, N = u && (s == null ? void 0 : s.minutes) === 0, w = N && (s == null ? void 0 : s.seconds) === 0, h = c(e.offer, e[l], {
    [e._children]: r,
    [e._pointer]: o || d
  }), p = 64, v = /* @__PURE__ */ n(z, { gap: 12, row: !0, align_center: !0, wide: !0, children: [
    i && /* @__PURE__ */ a(
      k,
      {
        className: c(e.image, e[l]),
        src: i,
        alt: "Sale",
        width: l === "covered" ? 456 : p,
        height: p,
        quality: 100,
        priority: !0
      }
    ),
    /* @__PURE__ */ n("div", { className: c(e.content), children: [
      /* @__PURE__ */ a("span", { className: e.title, children: g }),
      /* @__PURE__ */ n(
        "div",
        {
          className: c(e.timer, e[_], {
            [e._active]: s == null ? void 0 : s.formattedSeconds
          }),
          children: [
            /* @__PURE__ */ n(
              "div",
              {
                className: c(e.number, {
                  [e.ended]: f
                }),
                children: [
                  s == null ? void 0 : s.formattedDays,
                  " ",
                  /* @__PURE__ */ a("span", { className: e.notice, children: x })
                ]
              }
            ),
            /* @__PURE__ */ a("div", { className: e.colon, children: ":" }),
            /* @__PURE__ */ n(
              "div",
              {
                className: c(e.number, {
                  [e.ended]: u
                }),
                children: [
                  s == null ? void 0 : s.formattedHours,
                  " ",
                  /* @__PURE__ */ a("span", { className: e.notice, children: b })
                ]
              }
            ),
            /* @__PURE__ */ a("div", { className: e.colon, children: ":" }),
            /* @__PURE__ */ n(
              "div",
              {
                className: c(e.number, {
                  [e.ended]: N
                }),
                children: [
                  s == null ? void 0 : s.formattedMinutes,
                  " ",
                  /* @__PURE__ */ a("span", { className: e.notice, children: E })
                ]
              }
            ),
            /* @__PURE__ */ a("div", { className: e.colon, children: ":" }),
            /* @__PURE__ */ n(
              "div",
              {
                className: c(e.number, {
                  [e.ended]: w
                }),
                children: [
                  s == null ? void 0 : s.formattedSeconds,
                  " ",
                  /* @__PURE__ */ a("span", { className: e.notice, children: S })
                ]
              }
            )
          ]
        }
      )
    ] }),
    t && /* @__PURE__ */ a(
      "div",
      {
        className: c("material-icons", e.close),
        "data-icon": "close",
        onClick: t
      }
    )
  ] });
  return d ? /* @__PURE__ */ n(
    q,
    {
      href: d,
      scroll: !1,
      className: h,
      onClick: o,
      ...m,
      children: [
        v,
        r
      ]
    }
  ) : /* @__PURE__ */ n("div", { className: h, onClick: o, ...m, children: [
    v,
    r
  ] });
};
export {
  F as Offer
};
